import axios from "axios";
import { router } from "@/plugins/1.router";
import { errorHandler } from "../utils/errorHandler";
import { notifyBug } from "../utils/notifyBug";
import { discordService } from "@/plugins/discord";

function shouldIgnoreHttpError(error: any) {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || error?.message || "").toLowerCase();

  return status === 429 || message.includes("you are being rate limited");
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: `${import.meta.env.VITE_BASE_URL}/api`,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

axiosIns.interceptors.request.use(
  (config: any) => {
    const storaged = localStorage.getItem("user");
    const user = storaged && JSON.parse(storaged);

    if (user?.token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${user.token}`,
      };
    }

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

axiosIns.interceptors.response.use(null as any, (error: any) => {
  if (shouldIgnoreHttpError(error)) {
    return errorHandler(error);
  }

  // Bugsnag (existente)
  notifyBug(error);
  
  // Discord (novo)
  discordService.notifyError({
    type: 'http',
    error: error,
    context: {
      url: error.config?.url,
      method: error.config?.method?.toUpperCase(),
      status: error.response?.status,
      statusText: error.response?.statusText,
      requestData: error.config?.data,
      responseData: error.response?.data,
      url_page: window.location.href,
      route: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date(),
    },
    severity: error.response?.status >= 500 ? 'critical' : 'medium',
  });
  
  return errorHandler(error);
});

function redirectToLogout() {
  router.push("/logout");
}
export default axiosIns;
